import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "translateFloorplanTag",
  standalone: true,
})
export class TranslateFloorplanTagPipe implements PipeTransform {
  transform(tag: string): string {
    const tags: Record<string, string> = {
      TAG_1: $localize`:@@global.floorplanTags.tag1:Tag 1`,
      TAG_2: $localize`:@@global.floorplanTags.tag2:Tag 2`,
      TAG_3: $localize`:@@global.floorplanTags.tag3:Tag 3`,
      TAG_4: $localize`:@@global.floorplanTags.tag4:Tag 4`,
      TAG_5: $localize`:@@global.floorplanTags.tag5:Tag 5`,
    };

    return tags[tag] ?? $localize`:@@global.floorplanTags.unknown:Unknown tag`;
  }
}
